import {rpAppLink} from "@pg-mono/rp-routes";

import {OfferType} from "../types/OfferType";
import {offerUrlBuilder} from "./friendly_offer_list/offer_url_builder";

// popular price-filter thresholds we link to internally (price_1, in zł).
export const FLAT_PRICE_VARIANTS = [300000, 400000, 500000, 600000] as const;

const FLAT_PRICE_VARIANT_COUNT_KEYS: Record<(typeof FLAT_PRICE_VARIANTS)[number], string> = {
    300000: "up300k",
    400000: "up400k",
    500000: "up500k",
    600000: "up600k"
};

type IStatsWithPriceCounts = {properties_flats_count_by_price?: Record<string, number> | null} | null | undefined;

/**
 * Thresholds (300000/400000/500000/600000) that currently contain flat offers in the region.
 * Single source of truth for both the footer price links and the budget tile (the >= 3 rule).
 */
export const getAvailableFlatPriceVariants = (stats: IStatsWithPriceCounts): number[] => {
    const counts = stats?.properties_flats_count_by_price;

    if (!counts) {
        return [];
    }

    return FLAT_PRICE_VARIANTS.filter((threshold) => (counts[FLAT_PRICE_VARIANT_COUNT_KEYS[threshold]] ?? 0) > 0);
};

// Friendly listing URL for "new flats in {region} priced up to {priceTo} zł",
// e.g. (warszawa, 300000) → /s/nowe-mieszkania-warszawa-cena-do-300000-zl/
export const buildFlatPriceVariantUrl = (regionSlug: string, priceTo: number): string => {
    const {friendlySlug} = offerUrlBuilder({type: OfferType.FLAT, region: regionSlug, price_1: priceTo});

    return rpAppLink.offer.listFriendly({friendlySlug});
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {OfferType} from "../types/OfferType";
import {offerUrlBuilder} from "./friendly_offer_list/offer_url_builder";

// popular price-filter thresholds we link to internally (price_1, in zł).
export const FLAT_PRICE_VARIANTS = [300000, 400000, 500000, 600000] as const;

const FLAT_PRICE_VARIANT_COUNT_KEYS: Record<(typeof FLAT_PRICE_VARIANTS)[number], string> = {
    300000: "up300k",
    400000: "up400k",
    500000: "up500k",
    600000: "up600k"
};

type IStatsWithPriceCounts = {properties_flats_count_by_price?: Record<string, number> | null} | null | undefined;

/**
 * Thresholds (300000/400000/500000/600000) that currently contain flat offers in the region.
 * Single source of truth for both the footer price links and the budget tile (the >= 3 rule).
 */
export const getAvailableFlatPriceVariants = (stats: IStatsWithPriceCounts): number[] => {
    const counts = stats?.properties_flats_count_by_price;

    if (!counts) {
        return [];
    }

    return FLAT_PRICE_VARIANTS.filter((threshold) => (counts[FLAT_PRICE_VARIANT_COUNT_KEYS[threshold]] ?? 0) > 0);
};

// Friendly listing URL for "new flats in {region} priced up to {priceTo} zł",
// e.g. (warszawa, 300000) → /s/nowe-mieszkania-warszawa-cena-do-300000-zl/
export const buildFlatPriceVariantUrl = (regionSlug: string, priceTo: number): string => {
    const {friendlySlug} = offerUrlBuilder({type: OfferType.FLAT, region: regionSlug, price_1: priceTo});

    return rpAppLink.offer.listFriendly({friendlySlug});
};
